import React from "react";
import {observer} from "mobx-react";
import {InGameUserSessionTimerBox} from "./boxes/in-game-user-session-timer.box";
import classNames from 'classnames';
import {CyClass} from "../../../../../common/cy-classes";
import {PipeHorizontalSeparatorBox} from "../../../../basic-components/pipe-separator/pipe-horizontal-separator.box";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {SessionTimerValueComponent} from "../session-timer-value.component";


export enum InGameUserSessionTimerPipeSeparatorRenderPosition {
    None,
    Before,
    After
}

interface InGameUserSessionTimerComponentProps {
    className?: string;
    pipeSeparatorPosition?: InGameUserSessionTimerPipeSeparatorRenderPosition;
}

export const InGameUserSessionTimerComponent: React.FC<InGameUserSessionTimerComponentProps> = observer((props) => {
    const services = useServices();

    if(!services.sessionTimer.isEnabled) {
        return null;
    }

    const renderPipeSeparatorBefore = () => {
        if(props.pipeSeparatorPosition === InGameUserSessionTimerPipeSeparatorRenderPosition.Before) {
            return (<PipeHorizontalSeparatorBox/>);
        }
        return null;
    }

    const renderPipeSeparatorAfter = () => {
        if(props.pipeSeparatorPosition === InGameUserSessionTimerPipeSeparatorRenderPosition.After) {
            return (<PipeHorizontalSeparatorBox/>);
        }

        return null;
    }

    const renderValue = (value: string) => {
        return (
            <InGameUserSessionTimerBox className={classNames(props.className, CyClass('cy-session-timer'))}>
                {value}
            </InGameUserSessionTimerBox>
        );
    }


    return (
        <>
            {renderPipeSeparatorBefore()}
            <SessionTimerValueComponent renderValue={renderValue}/>
            {renderPipeSeparatorAfter()}
        </>
    );

})